export default function shortMonthDateBlog(dateData: string | number | Date) {
    const date = new Date(dateData)
    const formattedDate = date.toLocaleDateString('en-EN', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })

    return formattedDate
}
